import { Box, styled } from "@mui/material";

export const UserRoleBadgeContainer = styled(Box)({
    marginLeft: "4px",
    padding: "0 4px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "400",
    height: "fit-content",
});
